import React from "react";
import "./peak-hours.css";
import { Skeleton } from "components/skeleton";

export interface HourData {
  time: string;
  amount: string;
  pct: number; // 0–100
  isPeak?: boolean;
}

interface Props {
  hours: HourData[];
  title?: string;
  meta?: string;
  /** Show shimmer rows instead of data while payments load. */
  loading?: boolean;
}

// Bar-track widths for the loading skeleton rows.
const SK_ROW_WIDTHS = ["80%", "60%", "95%", "45%", "70%", "55%"];

function PeakHours({ hours, title = "Peak hours", meta, loading = false }: Props) {
  return (
    <section className="peak-hours">
      <div className="peak-hours__header">
        <h3 className="peak-hours__title">{title}</h3>
        {meta && <span className="peak-hours__meta">{meta}</span>}
      </div>

      {loading ? (
        <div className="peak-hours__list">
          {SK_ROW_WIDTHS.map((w, i) => (
            <div className="peak-hours__row" key={i}>
              <Skeleton width={40} height={12} />
              <Skeleton width={w} height={8} borderRadius="999px" />
              <Skeleton width={44} height={12} />
            </div>
          ))}
        </div>
      ) : hours.length === 0 ? (
        <div className="peak-hours__empty">No peak hours data.</div>
      ) : (
        <div className="peak-hours__list">
          {hours.map((h) => (
            <div key={h.time} className={`peak-hours__row${h.isPeak ? " peak-hours__row--peak" : ""}`}>
              <span className="peak-hours__time">{h.time}</span>
              <div className="peak-hours__bar-track">
                <span className="peak-hours__bar-fill" style={{ width: `${h.pct}%` }} />
              </div>
              <span className="peak-hours__amount">{h.amount}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default PeakHours;
